import React, { useState, useEffect } from 'react';
import { RiSearchLine, RiCloseLine } from 'react-icons/ri';
import { MdOutlineArrowOutward } from 'react-icons/md';
import apiClient from '../../services/apiClient';
import { useDispatch, useSelector } from 'react-redux';
import { setHistory } from '../../features/search/historySlice';

const SearchPopup = ({ isOpen, onClose, onSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchHistory, setSearchHistory] = useState([
    'Yoga mats',
    'Meditation cushions',
    'Rudraksha malas',
    'Incense sticks'
  ]);
  const dispatch = useDispatch();
  const history = useSelector(state => state.history.history); 

  const [popularTags, setPopularTags] = useState([]);

  useEffect(() => {
    const fetchKeywords = async () => {
      try {
        const res = await apiClient.get('/keywords');
        setPopularTags(res.data.map(keyword => ({ ...keyword, checked: false })) || []);
      } catch (err) {
        console.error('Error fetching keywords:', err);
      }
    };
    fetchKeywords();
  }, []);

  if (!isOpen) return null;

  // Handle search action
  const handleSearch = (term) => {
    if (!term) return;
    onSearch(term);

    // Update local state
    setSearchHistory((prev) => {
      if (prev.includes(term)) return prev;
      return [term, ...prev].slice(0, 5);
    });

    // Update Redux state
    dispatch(setHistory((prev => {
      if (history.includes(term)) return history;
      return [term, ...history].slice(0, 5);
    })(history)));

    setSearchQuery('');
  };


  return (
    <div className="searchOverlay">
      <div className="searchPopup">
        <button className="closeBtn" onClick={onClose}>
          <RiCloseLine />
        </button>

        {/* Search Input */}
        <div className="searchInputContainer">
          <input
            type="text"
            placeholder="Search for spiritual products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch(searchQuery);
              }
            }}
            className="searchInput"
          />
          <RiSearchLine
            className="searchIcon"
            onClick={() => handleSearch(searchQuery)}
            style={{ cursor: 'pointer' }}
          />
        </div>

        {/* Popular Tags */}
        <div className="tagsSection">
          <h3>Popular Spiritual Tags</h3>
          <div className="tagsContainer">
            {popularTags.map((tag, index) => (
              <span
                key={index}
                className="tag"
                onClick={() => handleSearch(tag.keyword)}
              >
                {tag.keyword}
              </span>
            ))}
          </div>
        </div>

        {/* History */}
        <div className="historySection">
          <h3>History</h3>
          <ul className="historyList">

            {history && history.map((item, index) => (
              <li
                key={index}
                className="historyItem"
                onClick={() => handleSearch(item)}
              >
                <span>{item}</span>
                <MdOutlineArrowOutward className="arrowIcon" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SearchPopup;
